import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { makePath } from 'helpers/link-generation';
import { bem } from 'helpers/class-name';
import { PFE_ICONS } from 'constants/icons';
import { Dropdown, Menu } from 'components/Dropdown';
import Message from 'components/Message';
import messages from '../../Schedules.messages';
import './SchedulePreview.scss';

const { element } = bem('schedule-preview');

const DROPDOWN_ITEMS = [
  {
    key: 'EDIT_SCHEDULE_INSTANCE',
    render: (venueId, scheduleId, recurrenceDate) => (
      <Message
        as={Link}
        className={element('edit-link')}
        to={makePath.scheduleInstanceEdit({
          venueId,
          scheduleId,
          occurrenceDate: recurrenceDate,
        })}
        message={messages.board.preview.editScheduleInstance}
      />
    ),
    action: () => {},
  },
  {
    key: 'CANCEL_SCHEDULE_INSTANCE',
    render: () => (
      <Message className={element('cancel-link')} message={messages.board.preview.cancelScheduleInstance} />
    ),
    action: ({ openModal, activeSchedule, cancelScheduleInstance }) =>
      openModal('CancelScheduleModal', { activeSchedule, cancelSchedule: cancelScheduleInstance }),
  },
];

class SchedulePreviewActions extends Component {
  static propTypes = {
    venueId: PropTypes.number,
    activeSchedule: PropTypes.shape({
      scheduleName: PropTypes.string,
      startDateTime: PropTypes.instanceOf(Date),
      scheduleId: PropTypes.number,
      recurrenceDate: PropTypes.string,
    }),
  };

  handleDropdownSelect = ({ action }) => action(this.props);

  render() {
    const {
      venueId,
      activeSchedule: { scheduleId, recurrenceDate },
    } = this.props;
    return (
      <Dropdown
        attachment="right"
        items={DROPDOWN_ITEMS}
        getKey={item => item.key}
        getText={item => item.key}
        renderMenuItem={(key, isSelected, item) => item.render(venueId, scheduleId, recurrenceDate)}
        onSelect={this.handleDropdownSelect}
        Toggle={({ toggleMenu }) => (
          <button type="button" onClick={toggleMenu}>
            <Isvg src={PFE_ICONS.threeDots} />
          </button>
        )}
        Content={Menu}
      />
    );
  }
}

export default SchedulePreviewActions;
